// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xPdpRealTimePricingLoading from "@awc/App/Handlers/XNG/PdpRealTimePricingLoading";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import {
    chain,
    SetProductInfo,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";

// Fix issue where changing the color dropdown does not update the price
export const LoadRealTimePricing: typeof SetProductInfo = props => {
    const { productInfo, selectedProductId: productId } = props;
    if (!productInfo || !productId) {
        return;
    }

    props.dispatch(xPdpRealTimePricingLoading({ isLoading: true }));

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: [productInfo],
            onSuccess: realTimePricing => {
                props.dispatch(xPdpRealTimePricingLoading({ isLoading: false }));
                const pricing = realTimePricing.realTimePricingResults!.find(
                    o => o.productId === productInfo.productId,
                );
                if (pricing) {
                    props.dispatch({
                        type: "Pages/ProductDetails/CompleteLoadRealTimePricing",
                        pricing,
                    });
                } else {
                    props.dispatch({
                        type: "Pages/ProductDetails/FailedLoadRealTimePricing",
                        productId,
                    });
                }
            },
            onError: () => {
                props.dispatch({
                    type: "Pages/ProductDetails/FailedLoadRealTimePricing",
                    productId,
                });
                props.dispatch(xPdpRealTimePricingLoading({ isLoading: false }));
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );
};

addToChainAfter(chain, SetProductInfo, LoadRealTimePricing);
